import 'slick-carousel/slick/slick.min'

$(document).ready(function () {
	$('.experience-slider').fadeIn()
	$('.experience-slider').slick({
		dots: false,
		infinite: false,
		speed: 300,
		slidesToShow: 3,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 1000,
				settings: {
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 750,
				settings: {
					slidesToShow: 1,
				},
			},
			// You can unslick at a given breakpoint now by adding:
			// settings: "unslick"
			// instead of a settings object
		],
	})
})
